import type { CatalogueCounty } from './types.js';

// U.S. Census Bureau 2020 county catalogue (national_county2020.txt, state FIPS 04). 15 counties.
export const ARIZONA_COUNTIES: readonly CatalogueCounty[] = [
  { name: "Apache", state: "AZ", fips: "04001" },
  { name: "Cochise", state: "AZ", fips: "04003" },
  { name: "Coconino", state: "AZ", fips: "04005" },
  { name: "Gila", state: "AZ", fips: "04007" },
  { name: "Graham", state: "AZ", fips: "04009" },
  { name: "Greenlee", state: "AZ", fips: "04011" },
  { name: "La Paz", state: "AZ", fips: "04012" },
  { name: "Maricopa", state: "AZ", fips: "04013" },
  { name: "Mohave", state: "AZ", fips: "04015" },
  { name: "Navajo", state: "AZ", fips: "04017" },
  { name: "Pima", state: "AZ", fips: "04019" },
  { name: "Pinal", state: "AZ", fips: "04021" },
  { name: "Santa Cruz", state: "AZ", fips: "04023" },
  { name: "Yavapai", state: "AZ", fips: "04025" },
  { name: "Yuma", state: "AZ", fips: "04027" },
];
